export const STEP_SELECT_TYPE = 'select-type';
export const STEP_SUCCESS = 'success';
export const STEP_INFO = 'info';
export const SINGLE_INVITE = 'single';
export const MULTIPLE_INVITE = 'multiple';
export const OPTION_SEND_LINK = 'send-link';
export const OPTION_FILL_INFO = 'fill-info';

export type ProcessInviteGuestStep = typeof STEP_SELECT_TYPE | typeof STEP_SUCCESS | typeof STEP_INFO;
export type InvitationType = typeof SINGLE_INVITE | typeof MULTIPLE_INVITE | '';
export type InvitationInfoType = typeof OPTION_SEND_LINK | typeof OPTION_FILL_INFO | '';
export interface InviteGuestForm {
  eventId: string;
  invitationId: string;
  quantity: number;
  type: InvitationType;
  infoType: InvitationInfoType;
  channelId: string;
  addOns?: string[];
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  gender?: string;
  nationality?: string;
  birth?: string;
  multiInviteText?: string;
}
